import { useTranslation } from 'react-i18next'

/** À droite du bandeau de prévisualisation : rien n'y est enregistré. */
function PreviewNoTrackingNotice() {
  const { t } = useTranslation()
  return <span className="hidden text-xs text-muted-foreground sm:inline">{t('scorm.preview.noTracking')}</span>
}

export default PreviewNoTrackingNotice
